import * as B from '../block'
import {Admin} from './admin'
import {meta} from './meta'

export const AttachmentsBlock = B.blockWithInfo(
  {...meta, Admin},
  ({
    config: {
      excludedSources,
      filterByUserLicenses,
      heading,
      iconSize,
      iconsEnabled,
    },
  }) => {
    const {tizraId} = B.useBlockContext()
    const content = B.useAttachmentsList({
      excludedSources,
      filterByUserLicenses,
      iconSize,
      iconsEnabled,
      tizraId,
    })
    return (
      <B.Scene>
        {content && <B.Section heading={heading}>{content}</B.Section>}
      </B.Scene>
    )
  },
)
